import React, { useState } from "react";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";

import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { useGetPhysiciansQuery } from "app/store/transmission/api/transmissionTableApi";
import { changePhysiciansFilter } from "app/store/transmission/slice/transmissionSlice";
import { resolveFollowingPhysicians } from "utils/transmissionTable.query";
import Loading from "components/common/loading/Loading";
import "components/pages/transmissions/filter/PhysicianFilter.css";

const PhysicianFilter = () => {
  const { physiciansFilter } = useSelector((state) => state.transmission);

  // Until the user picks, the list they follow is the selection.
  const physicians =
    physiciansFilter ??
    resolveFollowingPhysicians(localStorage.getItem("followingPhysicians"));

  const dispatch = useDispatch();
  const [filterExpanded, setFilterExpanded] = useState(
    () => physicians.length > 0
  );

  const { isLoading, isFetching, data } = useGetPhysiciansQuery({
    isPhysicianModal: true,
  });

  const activePhysicians = data?.filter((physician) =>
    Boolean(physician.active)
  );

  // Nothing to filter by (or still unknown): no title, no empty accordion.
  if (isLoading || !activePhysicians?.length) {
    return null;
  }

  return (
    <Accordion
      style={{ margin: "auto", border: "1px solid #e0e0e0", boxShadow: "none" }}
      expanded={filterExpanded}
      onChange={() => setFilterExpanded(!filterExpanded)}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <h3 style={{ fontSize: 18 }}>Physicians Filter</h3>
      </AccordionSummary>
      <AccordionDetails>
        {isLoading || isFetching ? (
          <Loading height={"50px"} />
        ) : (
          <div className="physicians-filter">
            <FormGroup className="physicians">
              {activePhysicians.map((p, i) => {
                return (
                  <FormControlLabel
                    key={i}
                    className=""
                    control={
                      <Checkbox
                        id={p.userId}
                        value={p.userId}
                        checked={physicians.includes(p.userId)}
                        name="checkedB"
                        color="primary"
                        onChange={(e) => {
                          dispatch(
                            changePhysiciansFilter(
                              physicians.includes(e.target.value)
                                ? physicians.filter(
                                    (id) => id !== e.target.value
                                  )
                                : [...physicians, e.target.value]
                            )
                          );
                        }}
                      />
                    }
                    label={
                      p.name.includes("Dr.") || p.name.includes("Dr ")
                        ? p.name
                        : `Dr. ${p.name}`
                    }
                  />
                );
              })}
            </FormGroup>
          </div>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default PhysicianFilter;
